import { Injectable } from '@angular/core';
import { BooxApiService, IStringAnyMap } from 'lib-boox';
import {map, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HeroAvatarService {

  constructor(
    private api: BooxApiService,
  ) { }

  /**
   * @description
   * Load the avatar from the server.
   *
   * @returns {Observable<string|null>} The avatar base 64 string or null if not found.
   */
  load() : Observable<string|null> {
    return this.api.get<IStringAnyMap>('/user/custom').pipe(
      map((response: IStringAnyMap) => response['resource']),
      map((resource : IStringAnyMap[]) => resource.find((custom : IStringAnyMap) => custom['name'] === 'avatar')),
      map((custom : IStringAnyMap|undefined) => custom ? custom['value'] : null),
    );
  }
}
